<template>
  <div>
    <div class="md:flex justify-end">
      <base-button
        outline
        type="primary"
        class="uppercase font-normal md:w-auto w-full text-sm flex"
        @click="savepost = true"
        ><feather-icon
          icon="BookmarkIcon"
          class="mr-2"
          svgClasses="w-4 h-4"
        ></feather-icon
        >Saved Posts</base-button
      >
      <CreatePost />
      <CreatePostSidebar v-show="PostCreateSidebar" />
    </div>
    <div class="mt-4" v-if="!savepost">
      <b-card
        no-body
        v-for="item in getUSerchannelfeed"
        :key="item._id"
        class="px-4 pt-4 shadow-md border mb-6"
      >
        <div class="flex justify-between mb-4">
          <div class="flex items-center">
            <!-- <img
              alt="user"
              class="w-9 rounded-full"
              :src="$imageURL + '/' + item.media[0]"
            /> -->
            <b-avatar
              variant="info "
              class="p-2 text-xl cust-avatar"
              size="lg"
            ></b-avatar>
            <!--v-else-->

            <div class="ml-4">
              <div class="flex items-center">
                <h4 class="font-semibold">
                  {{ item._user.firstname + " " + item._user.lastname }}
                </h4>
                <div class="mx-2 bg-primary w-1 h-1 rounded-full"></div>
                <!-- <h4 class="font-normal">{{ item.text }}</h4> -->
              </div>
              <p class="text-muted text-xs font-normal">
                {{ postTime(item.createdAt) }}
              </p>
            </div>
          </div>
          <div class="flex">
            <b-dropdown
              size="lg"
              variant="link"
              right
              toggle-class="text-decoration-none py-2 px-0 text-black cursor-pointer"
              no-caret
            >
              <!-- <template #button-content>
                <feather-icon
                  class="cursor-pointer text-black"
                  icon="MoreHorizontalIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </template> -->

              <b-dropdown-item>Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="md:mt-2 lg:mt-2 mt-0">
          <p
            class="md:text-base lg:text-base text-sm darktext font-normal md:mt-2 lg:mt-2 mt-0"
          >
            {{ item.text }}
          </p>

          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'image'">
            <img
              alt="postimage"
              class="rounded-lg postimght"
              :src="$imageURL + '/' + item.media[0]"
            />
          </div>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'video'">
            <video controls :src="$imageURL + '/' + item.media[0]"></video>
          </div>
          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'audio'">
            <audio controls :src="$imageURL + '/' + item.media[0]"></audio>
          </div>
          <div
            class="md:mt-4 lg:mt-4 mt-2 poll-radio"
            v-if="item.type === 'poll'"
          >
            <div v-for="choice in item.poll.choices" :key="choice._id" class="">
              <b-progress class="cust-pb" height="2.5rem">
                <b-progress-bar
                  :value="
                    calculatePercent(choice.totalVotes, item.poll.totalVotes)
                  "
                >
                  <div
                    class="flex w-full items-center justify-between absolute text-primary"
                  >
                    <p class="pl-6 clr333 font-semibold">{{ choice.text }}</p>

                    <p class="pr-12 text-base font-semibold">
                      {{
                        calculatePercent(
                          choice.totalVotes,
                          item.poll.totalVotes
                        ) || "0"
                      }}%
                    </p>
                  </div>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>

          <div class="md:mt-4 lg:mt-4 mt-2" v-if="item.type === 'url'">
            <link-prevue
              :apiUrl="$apiUrl + '/post/urlParser'"
              :url="item.url"
            ></link-prevue>
          </div>
        </div>

        <div class="reactions flex mt-3">
          <div class="flex items-center cursor-pointer">
            <img
              src="@/views/channel/img/lik.png"
              alt="like"
              class="w-4 h-4 my-auto"
            />
            <img
              src="@/views/channel/img/heart.png"
              alt="like"
              class="w-4 h-4 my-auto mx-1"
            />
            <img
              src="@/views/channel/img/laugh.png"
              alt="like"
              class="w-4 h-4 my-auto"
            />
          </div>
          <!-- <small class="ml-6">{{ item.totalLikes }}</small> -->
          <small class="ml-6">{{ item.totalLikes }}</small>
          <small class="mx-2">| </small>
          <!-- <small class=""
              >{{ item.totalComments }}
              {{ item.totalComments > 1 ? "Comments" : "Comment" }}</small
            > -->
          <small>{{ item.totalComments }}</small>
        </div>
        <div class="border-t-2 mt-4">
          <div class="flex my-2">
            <div class="w-1/2 flex justify-center">
              <!-- <LikePost
                  :postId="item._id"
                  :isLiked="!!item.isLiked.length"
                  :likeType="!!item.isLiked.length ? item.isLiked[0].type : ''"
                /> --><feather-icon
                icon="ThumbsUpIcon"
                class="mr-1"
                svgClasses="w-5 h-5"
              ></feather-icon
              >Like
            </div>
            <div
              class="w-1/2 flex justify-center cursor-pointer"
              @click="toggle = !toggle"
            >
              <feather-icon
                icon="MessageCircleIcon"
                svgClasses="w-5 h-5"
                class="mr-1"
              ></feather-icon
              >Comment
            </div>
            <!-- <div class="w-1/3 flex justify-center">
                <feather-icon icon="SendIcon" class="mr-1"></feather-icon>Share
              </div> -->
          </div>
        </div>
        <div v-show="toggle">
          <Comment />
          <!-- v-if="item.type !== 'poll'" -->
        </div>
      </b-card>
    </div>
    <div class="mt-4" v-show="savepost">
      <b-card
        no-body
        v-for="item in savedpost"
        :key="item.text"
        class="px-4 pt-4 shadow-md border mb-6"
      >
        <div class="flex justify-between mb-4">
          <div class="flex items-center">
            <!--<img
              alt="user"
              class="w-9 rounded-full"
              :src="likedUserImage"
              v-if="likedUserImage"
            />-->
            <b-avatar
              variant="info "
              class="p-2 text-xl cust-avatar"
              size="lg"
            ></b-avatar>
            <!--v-else-->

            <div class="ml-4">
              <div class="flex items-center">
                <h4 class="font-semibold">{{ item.name }}</h4>
                <div class="mx-2 bg-primary w-1 h-1 rounded-full"></div>
                <h4 class="font-normal">{{ item.channel }}</h4>
              </div>
              <p class="text-muted text-xs font-normal">
                about {{ item.postTime }} ago
              </p>
            </div>
          </div>
          <div class="flex">
            <b-dropdown
              size="lg"
              variant="link"
              right
              toggle-class="text-decoration-none py-2 px-0 text-black cursor-pointer"
              no-caret
            >
              <!-- <template #button-content>
                <feather-icon
                  class="cursor-pointer text-black"
                  icon="MoreHorizontalIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </template> -->

              <b-dropdown-item>Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="md:mt-2 lg:mt-2 mt-0">
          <p
            class="md:text-base lg:text-base text-sm darktext font-normal md:mt-2 lg:mt-2 mt-0"
          >
            {{ item.text }}
          </p>
          <div class="md:mt-4 lg:mt-4 mt-2">
            <img
              alt="postimage"
              class="rounded-lg postimght w-full"
              :src="item.postimage"
            />
          </div>
        </div>
        <div class="reactions flex mt-3">
          <div class="flex items-center cursor-pointer">
            <img
              src="@/views/channel/img/lik.png"
              alt="like"
              class="w-4 h-4 my-auto"
            />
            <img
              src="@/views/channel/img/heart.png"
              alt="like"
              class="w-4 h-4 my-auto mx-1"
            />
            <img
              src="@/views/channel/img/laugh.png"
              alt="like"
              class="w-4 h-4 my-auto"
            />
          </div>
          <!-- <small class="ml-6">{{ item.totalLikes }}</small> -->
          <small class="ml-6">4</small>
          <small class="mx-2">|</small>
          <!-- <small class=""
              >{{ item.totalComments }}
              {{ item.totalComments > 1 ? "Comments" : "Comment" }}</small
            > -->
          <small>2 comments</small>
        </div>
        <div class="border-t-2 mt-4">
          <div class="flex my-2">
            <div class="w-1/2 flex justify-center">
              <!-- <LikePost
                  :postId="item._id"
                  :isLiked="!!item.isLiked.length"
                  :likeType="!!item.isLiked.length ? item.isLiked[0].type : ''"
                /> --><feather-icon
                icon="ThumbsUpIcon"
                class="mr-1"
                svgClasses="w-5 h-5"
              ></feather-icon
              >Like
            </div>
            <div
              class="w-1/2 flex justify-center cursor-pointer"
              @click="toggle = !toggle"
            >
              <feather-icon
                icon="MessageCircleIcon"
                svgClasses="w-5 h-5"
                class="mr-1"
              ></feather-icon
              >Comment
            </div>
            <!-- <div class="w-1/3 flex justify-center">
                <feather-icon icon="SendIcon" class="mr-1"></feather-icon>Share
              </div> -->
          </div>
        </div>
        <div v-show="toggle">
          <Comment />
          <!-- v-if="item.type !== 'poll'" -->
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Comment from "./components/Comment.vue";
import CreatePostSidebar from "@/layout/main/components/navbar/components/CreatePostSidebar";
import { mapState } from "vuex";
import CreatePost from "./CreatePost.vue";
export default {
  components: {
    Comment,
    CreatePostSidebar,
    CreatePost,
  },
  data() {
    return {
      savepost: false,

      toggle: false,
    };
  },

  methods: {
    createPost() {
      // this.toggleCreatePostSidebar(true);
      this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
    },
    calculatePercent(votes, totalvotsbyuser) {
      return parseInt((votes / totalvotsbyuser) * 100);
    },
    postTime(time) {
      const distanceInWordsToNow = require("date-fns/distance_in_words_to_now");
      return `${distanceInWordsToNow(time)} ago`;
    },
    async GetUserPost() {
      const data = await this.$store.dispatch(
        "posts/setUserChannelFeeds",
        this.user._id
      );
    },
  },
  async mounted() {
    this.GetUserPost();
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("posts", ["getUSerchannelfeed"]),
    ...mapState("UI", ["PostCreateSidebar"]),
  },
};
</script>

<style>
.cust-pb > .progress-bar {
  background-color: #cbedf2 !important;
}
</style>
